import { clearClientLogic } from './clearClientLogic';
import { fetchAppVersionLogic } from './fetchAppVersionLogic';

export const logic = [clearClientLogic, fetchAppVersionLogic];
